module.exports = __webpack_public_path__ + "img/box-arrow-left.f5d69802.svg";